import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import { apiUrl } from "../commons/inFormTypes";
import {  useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoaderBtn from "../components/LoaderBtn";
import useCheckUser from "../custom-hooks/useCheckUser";
import useViewport from "../custom-hooks/useViewport ";



function Amlak() {
  const [ address, setAddress ] = useState("");
  const [ code, setCode ] = useState("");
  const [load, setLoad] = useState(false);
  const [ isSubmit, setIsSubmit ] = useState(false);
  const [ seenList, setSeenList ] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const navigate  = useNavigate();
  const { width } = useViewport();


   // Example usage of the custom hook
   useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
      const axios = require("axios");
      axios.post(apiUrl + "GetDevice", {
        Uid: UserID,
      }).then((res) => {
        if (res.data.result === "true") {
          setSeenList(res.data.data);
        } else {
        }
      });   
  }, [isSubmit]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if ( code === "" || address === "" ) {
      toast.error("لطفا اطلاعات را تکمیل کنید ", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return;
    }
    setLoad(true);
    const axios = require("axios");
    axios
      .post(apiUrl + "InsertDev", {
        Pid: UserID,
        Code: code,
        Address: address,
        Uid: UserID
      })
      .then((res) => {
        setLoad(false);
        setAddress("");
        setCode("");
        if (res.data.result === "true") {
          if (!isSubmit)
          { setIsSubmit(true);}
          else 
          {setIsSubmit(false);} 

          toast.success(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  };

  return (
    <div className="pt-5">
      <Container>
        <Row className="justify-content-center">
          <Col xs={7} className="text-right rgc-title">
          <h3>املاک من</h3>

          
          <Form>
              <Row className="justify-content-center">
                <Col md="12" className="mb-3">

                </Col>

                <Col md="10" className="mb-3">
                  <Form.Group>
                    <Form.Label>کد:</Form.Label>
                    <Form.Control
                      className="rgc-font-number"
                      placeholder="کد"
                      type={width >820 ? "text":"number"}
                      value={code}                      
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) => setCode(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </Col>

                <Col md="10">
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>آدرس:</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      className="rgc-font-number"
                      placeholder="آدرس"
                      type="text"
                      value={ address }
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Form.Group>
                </Col>

                

                <Col xs="9" md="5" className="text-center">
                  <Button
                    className="btn-fill rgc-btn"
                    type="submit"
                    variant="primary"
                    onClick={handleSubmit}
                  >
                    <LoaderBtn loads={load} />
                    <span>ثبت</span>
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>

          
        </Row>
      </Container>

      <div className="rgc-toast">
      <ToastContainer
        autoClose={3000}
				/>
      </div>
    </div>
  );
}
export default Amlak;
